import { readJson, writeJson } from "@/lib/toolkit/storage";

export type ScenarioProgress = {
  /** Highest stage index the reader has reached (0-based). */
  stage: number;
  /** True once the reader has passed the final stage. */
  done: boolean;
  at: number;
};

type ProgressMap = Record<string, ScenarioProgress>;

const KEY = "wi_scenario_progress";
const MAX_ENTRIES = 120;

/**
 * Local-only reading progress for WHAT IF? scenarios. Nothing is sent to the
 * backend — this is a convenience for the device, mirroring the toolkit's
 * localStorage helpers.
 */
export function readAllProgress(): ProgressMap {
  const raw = readJson<ProgressMap>(KEY, {});
  return raw && typeof raw === "object" ? raw : {};
}

export function readProgress(slug: string): ScenarioProgress | undefined {
  const entry = readAllProgress()[slug];
  return entry && typeof entry.stage === "number" ? entry : undefined;
}

export function saveProgress(slug: string, stage: number, done: boolean) {
  const all = readAllProgress();
  const prev = all[slug];
  all[slug] = {
    stage: Math.max(0, prev && !done ? Math.max(prev.stage, stage) : stage),
    done: done || Boolean(prev?.done),
    at: Date.now(),
  };
  const entries = Object.entries(all)
    .sort((a, b) => b[1].at - a[1].at)
    .slice(0, MAX_ENTRIES);
  writeJson(KEY, Object.fromEntries(entries));
}

export function clearProgress(slug: string) {
  const all = readAllProgress();
  delete all[slug];
  writeJson(KEY, all);
}

export const SCENARIO_PROGRESS_KEY = KEY;
